import Vue from 'vue';
import Storage from 'vue-ls';

var options = {
  namespace: 'synpse__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
};

Vue.use(Storage, options);